import { Component, Input, OnInit } from '@angular/core';
import { Office, OfficeSearch, Official, VoterVoiceService } from 'src/app/integrations/voter-voice/shared';
import { ProfileRead } from '../../shared/profile-read.model';
import { VoterVoiceProfileReadDto } from 'src/app/integrations/voter-voice/shared/voter-voice-profile-read.dto';
import { GovernmentDto } from 'src/app/integrations/voter-voice/shared/government.dto';
import { ProfileViewVoterVoiceDto } from 'src/app/integrations/voter-voice/shared/profile-view-voter-voice.dto';

@Component({
  selector: 'wl-profile-view-voter-voice',
  templateUrl: './profile-view-voter-voice.component.html',
  styleUrls: ['./profile-view-voter-voice.component.less'],
    standalone: false
})
export class ProfileViewVoterVoiceComponent implements OnInit {
  @Input() profileId: number;
  profile: ProfileRead;
  voterVoiceProfile : VoterVoiceProfileReadDto[];
  voterVoiceGovernments: Array<GovernmentDto>;
  voterVoiceOfficials: Array<Official>;
  voterVoiceOffices: Array<Office>;
  voterVoices: ProfileViewVoterVoiceDto[] = [];

  constructor(private _voterVoiceService: VoterVoiceService) {}

  async ngOnInit(): Promise<void> {
    let search: OfficeSearch = new OfficeSearch();
    search.PageSize = 99999
    this.voterVoiceProfile = await this._voterVoiceService.getProfileVoterVoiceOfficials(this.profileId);
    this.voterVoiceGovernments = await this._voterVoiceService.getVoterVoiceGovernments();
    this.voterVoiceOfficials = (await this._voterVoiceService.searchOfficials(search))?.Result;
    this.voterVoiceOffices = (await this._voterVoiceService.searchOffices(search))?.Result;

    if(this.voterVoiceProfile && this.voterVoiceGovernments && this.voterVoiceOfficials && this.voterVoiceOffices){
      for(let profile of this.voterVoiceProfile){
        let official = this.voterVoiceOfficials.find(x => x.OfficialUniqueId === profile.OfficialUniqueId);
        let office = this.voterVoiceOffices.find(x => x.OfficeUniqueId === profile.OfficeUniqueId);
        let government = this.voterVoiceGovernments.find(x => x.governmentUniqueId === profile.GovernmentUniqueId);

        if (!official && !office && !government) {
          continue;
        }

        let voterVoice = {
          Government: government?.name || "",
          OfficialName: official?.displayName || "",
          OfficialParty: official?.party || "",
          OfficialTitle: official?.title || "",
          OfficeElectedBody: office?.electedBody || "",
          OfficeElectoralConstituency: office?.constituency || "",
        };

        this.voterVoices.push(voterVoice);
      }
    }
  }

}
